import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { videoConfig } from '../config/videos'

function MerchantCenter() {
  const [selectedVideo, setSelectedVideo] = useState(null)
  const [videos, setVideos] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadVideos()
  }, [])

  const loadVideos = async () => {
    try {
      console.log('Lade Videos aus Bucket:', videoConfig.bucketName)
      
      const folderPath = videoConfig.folderPath || ''
      
      // Bekannte Video-Dateinamen aus dem Supabase Storage (aus MCP Query)
      const knownVideoFiles = [
        '1770323134374-3yfk6.MP4',
        '1770323216990-g29z19.MP4',
        '1770323248051-081iv9.MP4',
        '1770323286182-k2iow.MOV',
        '1770323312311-e4q34c.MOV',
        '1770323531293-hptqcl.MOV',
        '1770323874949-a46oq.mp4',
        '1770323901372-qbtad.mp4',
        '1770323923183-9b4nhi.MOV',
        '1770323953518-6w2ay.MOV'
      ]

      // Versuche zuerst, die Dateien über die Storage API zu laden
      let files = []
      try {
        const { data: listedFiles, error } = await supabase.storage
          .from(videoConfig.bucketName)
          .list(folderPath, {
            limit: 100,
            offset: 0,
            sortBy: { column: 'name', order: 'asc' }
          })

        if (!error && listedFiles && listedFiles.length > 0) {
          files = listedFiles
          console.log('Dateien über Storage API geladen:', files.length)
        } else {
          console.log('Storage API gibt keine Dateien zurück, verwende bekannte Dateien')
          files = knownVideoFiles.map(name => ({ name }))
        }
      } catch (apiError) {
        console.warn('Fehler beim Laden über Storage API, verwende bekannte Dateien:', apiError)
        files = knownVideoFiles.map(name => ({ name }))
      }

      // Wenn keine Dateien gefunden wurden, verwende die bekannten
      if (files.length === 0) {
        console.log('Keine Dateien gefunden, verwende bekannte Video-Dateien')
        files = knownVideoFiles.map(name => ({ name }))
      }

      // Filtere Video-Dateien (mp4, mov, webm - auch Großbuchstaben)
      const videoFiles = files.filter(file => {
        const fileName = typeof file === 'string' ? file : file.name
        const ext = fileName.toLowerCase().split('.').pop()
        return ['mp4', 'mov', 'webm'].includes(ext)
      })

      console.log('Video-Dateien gefunden:', videoFiles.length)
      videoFiles.forEach(file => {
        const fileName = typeof file === 'string' ? file : file.name
        console.log('-', fileName)
      })

      // Videos mit Public URLs mappen
      const videosWithUrls = videoFiles.map((file, index) => {
        // Dateiname kann ein String oder ein Objekt sein
        const fileName = typeof file === 'string' ? file : file.name
        
        // Wenn der Dateiname bereits den Pfad enthält, verwende ihn direkt
        // Sonst füge den folderPath hinzu
        let filePath
        if (fileName.includes('/')) {
          // Dateiname enthält bereits den Pfad (z.B. "64ba623b-a57e-42c1-951d-0fef7035a435/1770323134374-3yfk6.MP4")
          filePath = fileName
        } else {
          // Dateiname ist nur der Dateiname, füge folderPath hinzu
          filePath = folderPath ? `${folderPath}/${fileName}` : fileName
        }
        
        const { data } = supabase.storage
          .from(videoConfig.bucketName)
          .getPublicUrl(filePath)
        
        console.log(`Video ${index + 1}:`, {
          fileName: fileName,
          filePath: filePath,
          url: data.publicUrl
        })

        // Extrahiere nur den Dateinamen ohne Pfad für die Namenserkennung
        const fileNameOnly = fileName.split('/').pop() || fileName
        const fileNameLower = fileNameOnly.toLowerCase()
        let name = 'Video Beispiel'
        
        if (fileNameLower.includes('mercedes')) {
          name = 'Mercedes'
        } else if (fileNameLower.includes('nutella')) {
          name = 'Nutella'
        } else if (fileNameLower.includes('audi')) {
          name = 'Audi'
        } else if (fileNameLower.includes('persil')) {
          name = 'Persil'
        }

        return {
          id: index + 1,
          name: name,
          fileName: fileNameOnly,
          filePath: filePath,
          url: data.publicUrl,
          description: `${name} Kampagne - Beispiel für korrektes Video-Format`
        }
      })

      console.log('Videos mit URLs:', videosWithUrls.length)
      setVideos(videosWithUrls)
    } catch (error) {
      console.error('Fehler beim Laden der Videos:', error)
    } finally {
      setLoading(false)
    }
  }

  const guidelines = [
    {
      title: 'Video-Format',
      items: [
        'Maximale Länge: 5 Sekunden',
        'Unterstützte Formate: MP4, MOV, WebM',
        'Empfohlene Auflösung: 1080x1920 (Portrait) oder 1920x1080 (Landscape)',
        'Maximale Dateigröße: 10 MB'
      ]
    },
    {
      title: 'Inhaltliche Richtlinien',
      items: [
        'Videos müssen klar und verständlich sein',
        'Keine irreführenden Inhalte',
        'Keine Gewalt oder anstößige Inhalte',
        'Produktinformationen müssen korrekt sein',
        'Keine Personen in den Anzeigen erlaubt – auch keine KI-generierten Personen (No-People-Policy)'
      ]
    },
    {
      title: 'Technische Anforderungen',
      items: [
        'Videos müssen automatisch abspielbar sein',
        'Keine Audio-Wiedergabe erforderlich',
        'X-Button erscheint nach 3 Sekunden',
        'Video darf maximal 5 Sekunden lang sein'
      ]
    },
    {
      title: 'Upload-Prozess',
      items: [
        'Videos über das Merchant Center hochladen',
        'Automatische Validierung des Formats',
        'Manuelle Freigabe durch spotx Team',
        'Nach Freigabe sofort verfügbar'
      ]
    }
  ]

  return (
    <section className="merchant-center section">
      <div className="container">
        <div className="merchant-header">
          <h1 className="merchant-title">Merchant Center</h1>
          <p className="merchant-subtitle">
            Video-Beispiele und Richtlinien für Merchants
          </p>
        </div>

        <div className="merchant-content">
          <div className="merchant-guidelines">
            <h2 className="guidelines-title">Richtlinien & Anforderungen</h2>
            <div className="guidelines-grid">
              {guidelines.map((guideline, index) => (
                <div key={index} className="guideline-card">
                  <h3 className="guideline-card-title">{guideline.title}</h3>
                  <ul className="guideline-list">
                    {guideline.items.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="merchant-videos">
            <h2 className="videos-title">Video-Beispiele</h2>
            <p className="videos-subtitle">
              Diese Videos zeigen, wie Ihre Kampagnen-Videos aussehen sollten
            </p>
            {loading ? (
              <div className="videos-loading">
                <p>Videos werden geladen...</p>
              </div>
            ) : videos.length === 0 ? (
              <div className="videos-error">
                <p>Keine Videos gefunden.</p>
                <p style={{ fontSize: '14px', color: 'rgba(255, 255, 255, 0.5)', marginTop: '10px' }}>
                  Bitte überprüfen Sie die Browser-Konsole für Details.
                </p>
              </div>
            ) : (
              <div className="videos-grid">
                {videos.map((video) => (
                <div
                  key={video.id}
                  className="video-card"
                  onClick={() => setSelectedVideo(video)}
                >
                  <div className="video-thumbnail">
                    <video
                      src={video.url}
                      preload="metadata"
                      muted
                      playsInline
                      onLoadedMetadata={(e) => {
                        const videoEl = e.target
                        videoEl.currentTime = 0.5
                      }}
                    />
                    <div className="video-play-overlay">
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="white">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </div>
                    <div className="video-duration-badge">5 Sek.</div>
                  </div>
                  <div className="video-info">
                    <h3 className="video-name">{video.name}</h3>
                    <p className="video-description">{video.description}</p>
                  </div>
                </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {selectedVideo && (
          <div className="video-modal" onClick={() => setSelectedVideo(null)}>
            <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
              <button
                className="video-modal-close"
                onClick={() => setSelectedVideo(null)}
                aria-label="Schließen"
              >
                ×
              </button>
              <div className="video-modal-player-wrapper">
                <video
                  src={selectedVideo.url}
                  controls
                  autoPlay
                  playsInline
                  className="video-modal-player"
                />
              </div>
              <div className="video-modal-info">
                <h3>{selectedVideo.name}</h3>
                <p>{selectedVideo.description}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default MerchantCenter
